import axios from "axios";
import * as _ from "lodash";
import log2 from "../utils/log2";

let SOCKET_URL = process.env.SOCKET_URL;
const log = log2("hostFetcher");
const request = axios.create({
    baseURL: SOCKET_URL,
    timeout: 20000, // request timeout
});

const lastSocketServers = {
    servers: [],
    fetchTime: Date.now(),
    failedServers: [],
};
const isValidResponse = (servers) => {
    const selfHost = servers.find((x) => x.self);
    if (selfHost && selfHost.ready) return true;
    else return false;
};

const performUpdateSocketServers = () => {
    log.debug("updating socket servers");
    request
        .get("/hosts")
        .then((res) => {
            log.debug("updateSocketServers", res.data);
            const servers = res.data;
            if (isValidResponse(servers)) {
                lastSocketServers.servers = servers;
                lastSocketServers.fetchTime = Date.now();
                lastSocketServers.failedServers = [];
            } else {
                log.warn("Socket Servers is not valid, re-fetch will run in a seconds ");
                setTimeout(updateSocketServers, 1000);
            }
        })
        .catch((err) => {
            console.error(err);
            log.error("Socket servers fetch error", { err: err.message });
            setTimeout(updateSocketServers, 2000);
        });
};
const updateSocketServers = _.debounce(performUpdateSocketServers, 1000);

updateSocketServers();
let nextCallCount = 0;
const getValidServers = () => {
    const allServers = [...lastSocketServers.servers];
    const failedServers = [...lastSocketServers.failedServers];

    const validServers = _.orderBy(
        allServers.filter((x) => x.ready && !x.circuitBreaker),
        ["cpu.load", "uptime"],
        ["asc", "desc"]
    ).filter((x) => !failedServers.includes(x.instanceId));
    return {
        allServers,
        failedServers,
        validServers,
    };
};
export const getNextSocketServerCandidate = (print) => {
    if (nextCallCount === 0) performUpdateSocketServers();
    nextCallCount++;

    const { allServers, failedServers, validServers } = getValidServers();
    log.debug("validServers", validServers);
    if (print)
        log.debug("getNextSocketServerCandidate", {
            allServers: allServers.map((x) => _.takeRight(x.instanceId, 3).join("")),
            failedServers: failedServers.map((x) => _.takeRight(x, 3).join("")),
            validServers: validServers.map((x) => _.takeRight(x.instanceId, 3).join("")),
        });
    const candidateServer = _.head(validServers);
    if (!candidateServer && allServers.length === failedServers.length && validServers.length === 0) {
        if (Date.now() - lastSocketServers.fetchTime >= 20000) {
            performUpdateSocketServers();
        } else {
            updateSocketServers();
        }
    }

    return candidateServer;
};

export const markFailedSocketServer = (id) => {
    lastSocketServers.failedServers.push(id);
    lastSocketServers.failedServers = _.uniq(lastSocketServers.failedServers);
    log.debug("markFailedSocketServer", id, lastSocketServers.failedServers);
    if (!getNextSocketServerCandidate(true)) {
        updateSocketServers();
    }
};

setInterval(() => {
    log.info("20sec socket servers fetch timer running");
    const { allServers, failedServers, validServers } = getValidServers();
    const candidateServer = _.head(validServers);
    if (!candidateServer) performUpdateSocketServers();
}, 20 * 1000);
